<template>
  <sea-page title="Notifiche" showCompanyHeader>
    <sea-page-content
      ref="list"
      :fetchList="fetchList"
      :resetList="resetList"
      :deleteItems="deleteItems"
      toolbar
      searchPanel
      hide-data-pub
      pulsanteAggiorna
      pulsanteAggiungi
      @pulsanteAggiungiClick="createItem"
      pulsanteCronologiaNotifiche
      pulsante-elimina
      :pulsanteEliminaDisabled="false"
      history-dir="notices"
    >
      <template v-slot:table="{ attrs, height }">
        <v-data-table
          v-model="attrs.selected"
          v-bind="attrs"
          :headers="headers"
          :items="items"
          sort-by="data"
          sort-desc
          dense
          :expanded="expanded"
          item-key="id"
          :height="height"
          show-select
          @click:row="rowClick"
        >
          <template v-slot:item.data="{ item }">
            {{ item.data | dateFormat }}
          </template>
          <template v-slot:item.actions="{ item }">
            <v-btn
              elevation="2"
              rounded
              x-small
              @click.stop="clicked(item)"
              :color="colors.primarycolor"
              dark
            >
              Dettaglio
              <v-icon right>mdi-cloud-download-outline </v-icon>
            </v-btn>
          </template>
          <template v-slot:expanded-item="{ headers, item }">
            <td :colspan="headers.length">
              <div>{{ item.testo }}</div>
            </td>
          </template>
        </v-data-table>
      </template>
    </sea-page-content>
  </sea-page>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import mixin from "@/mixin";

const headers = [
  {
    text: "Data",
    value: "data",
    class: "heading",
    cellClass: "text-little-2 hand",
  },
  {
    text: "Titolo",
    value: "titolo",
    sortable: false,
    class: "heading",
    cellClass: "text-little-2 hand",
  },
  {
    text: "",
    value: "actions",
    sortable: false,
    align: "end",
    class: "heading",
    cellClass: "text-little-2 hand",
  },
];

export default {
  name: "notices",
  mixins: [mixin],
  data() {
    return {
      expanded: [],
      headers,
      editedIndex: -1,
      editedItem: {
        id: 0,
        data: "",
        titolo: "",
        testo: "",
      },
      defaultItem: {
        id: 0,
        data: "",
        titolo: "",
        testo: "",
      },
    };
  },
  methods: {
    ...mapActions({
      fetchList: "board/fetchNotices",
      resetList: "board/resetNotices",
      _deleteItems: "board/deleteNotices",
    }),
    deleteItems() {
      this._deleteItems(
        this.$refs.list.attrs.selected.map((notice) => notice.id)
      ).then(() => {
        this.$refs.list.attrs.selected = [];
        this.$refs.list.updateList();
      });
    },
    createItem() {
      this.$router.push("/company/notices/new");
    },
    rowClick(_, row) {
      row.select(!row.isSelected);
    },
    clicked(value) {
      const index = this.expanded.indexOf(value);
      if (index === -1) {
        this.expanded.length = 0;
        this.expanded.push(value);
      } else {
        this.expanded.splice(index, 1);
      }
    },
  },
  computed: {
    ...mapGetters({
      items: "board/notices",
    }),
  },
};
</script>

<style scoped>
table.storico {
  margin: 5px;
}
table.storico,
table.storico > tr > th,
td {
  border: 1px solid black;
}
table.storico > tr > th,
td {
  padding: 5px;
}
</style>
